import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LogoutEffect } from './effects/logout-effect';
import { TokenRefreshEffect } from './effects/token-refresh-effect';
import { SessionInviteCreationEffect } from './effects/session-invite-creation';
import { BrowserWarningEffect } from './effects/browser-warning-effect';
import { SyncArchiveEffect } from './effects/sync-archive-effect';
import { SyncCloudEffect } from './effects/sync-cloud-effect';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    LogoutEffect,
    TokenRefreshEffect,
    SessionInviteCreationEffect,
    BrowserWarningEffect,
    SyncArchiveEffect,
    SyncCloudEffect,
  ],
})
export class AppComponent implements OnInit {
  constructor(
    protected logoutEffect: LogoutEffect,
    protected tokenRefreshEffect: TokenRefreshEffect,
    protected SessionInviteCreationEffect: SessionInviteCreationEffect,
    protected syncCloudEffect: SyncCloudEffect,
    protected browserWarningEffect: BrowserWarningEffect,
    protected syncArchiveEffect: SyncArchiveEffect,
  ) {}

  ngOnInit() {
    this.logoutEffect.use();
    this.tokenRefreshEffect.use();
    this.SessionInviteCreationEffect.use();
    this.syncCloudEffect.use();
    this.browserWarningEffect.use();
    this.syncArchiveEffect.use();
  }
}
